import { render, staticRenderFns } from "./Layout6.vue?vue&type=template&id=d2a90558"
import script from "./Layout6.vue?vue&type=script&lang=js"
export * from "./Layout6.vue?vue&type=script&lang=js"
import style0 from "./Layout6.vue?vue&type=style&index=0&id=d2a90558&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports